// extracted by mini-css-extract-plugin
module.exports = {"shadow":"LoadingText_shadow__3lEnd","loading":"LoadingText_loading__SzvTg","dots":"LoadingText_dots__1qiic"};